import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { Color4 } from "core/Maths/math.color";
import { ColorPickerPopup } from "../../primitives/colorPicker";
import { ControlledColorPropertyLine } from "./colorPropertyLineCore";
const Picker = (props) => _jsx(ColorPickerPopup, { ...props });
const Adapter = {
    picker: Picker,
    getColor: (value) => value,
    createColor: (color, source) => {
        if (source instanceof Color4) {
            return new Color4(color.r, color.g, color.b, color.a ?? source.a);
        }
        return source.clone().set(color.r, color.g, color.b);
    },
};
const ColorPropertyLine = forwardRef((props, ref) => _jsx(ControlledColorPropertyLine, { ...props, adapter: Adapter, propertyLineRef: ref }));
ColorPropertyLine.displayName = "ColorPropertyLine";
/**
 * Edits a Babylon.js Color3 value.
 * @param props The controlled color and property-line presentation.
 * @returns The Color3 property line.
 */
export const Color3PropertyLine = ColorPropertyLine;
/**
 * Edits a Babylon.js Color4 value.
 * @param props The controlled color and property-line presentation.
 * @returns The Color4 property line.
 */
export const Color4PropertyLine = ColorPropertyLine;
//# sourceMappingURL=colorPropertyLine.js.map